import Iconify from "minimals-template/components/Iconify"
import AppWidget from "minimals-template/pages/sections/@dashboard/general/app/AppWidget.js"

export function AiTypeReviewWidgetCard({ item }) {
    const outline = setOutlined()

    return (
        <AppWidget
            onClick={item.onClick}
            data-cy={item.dataCy}
            component="button"
            sx={{
                cursor: "pointer",
                outline,
                outlineColor: item.outlineColor,
            }}
            title={item.title}
            color={item.color}
            total={item.total}
            widgetIconColor={item.iconColor}
            widgetIconSize={item.iconSize}
            widgetIcon={<Iconify icon={item.icon} />}
            chartData={{
                series: [item.percentage],
            }}
        />
    )

    function setOutlined() {
        if (item.isActive) return "2px solid"
        return "none"
    }
}
